import { type Common } from './common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async checkExistenceByPrevisit(previsitFormSetId: string): Promise<{ exists: boolean }> {
    // uses built-in auth to find valid SSN, if any
    const url = this.common.constructPath(`/patient-previsit/ssn`, {
      previsitFormSetId,
    });
    return await this.common.getJSON(url);
  }

  async checkExistenceByEhrInformationId(ehrInformationId: string): Promise<{ exists: boolean }> {
    const url = this.common.constructPath(
      `/ehr-information/${ehrInformationId}/patient-ssns/exists`
    );
    return await this.common.getJSON(url);
  }

  async getSsn4ByEhrInformationId(ehrInformationId: string): Promise<{ ssn4: string }> {
    const url = this.common.constructPath(`/ehr-information/${ehrInformationId}/patient-ssns/ssn4`);
    return await this.common.getJSON(url);
  }

  async upsert(ssn: string, previsitFormSetId: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/patient-previsit/ssn`);
    return await this.common.postJSON(url, { ssn, previsitFormSetId });
  }
}
